'use strict';

angular
    .module('dstreamApp.components')
    .component('dsOutOfOffice', {
        templateUrl: 'app/components/outOfOffice/ds-out-of-office.html',
        controller: DsOutOfOfficeController,
        bindings: {
            groupMembers: '=',
            users: '='
        }
    });

/* @ngInject */
function DsOutOfOfficeController($rootScope, $scope, webServices, invoiceService, constants, companyDataService) {
    var ctrl = this;
    ctrl.DATE_EE_FORMAT = constants.DATE_EE_FORMAT;
    $scope.Substitute = {};

    /********** SCOPE FUNCTIONS **********/

    var authorizationDataLoadedEvent = $rootScope.$on("authorizationDataLoaded", function () {
        getCurrentSubstitute();
    });

    $scope.openModal = function (e) {
        e.preventDefault();
        $rootScope.modalInstance.open({
            templateUrl: 'app/components/outOfOffice/ds-out-of-office-modal.html',
            controller: 'DsOutOfOfficeModalController',
            windowClass: 'outofoffice-modal',
            scope: $scope,
        });
    };

    /********** NON-SCOPE FUNCTIONS **********/

    /*
        Get current users substitute
     */
    function getCurrentSubstitute() {
        if ($rootScope.userData.BOGuid) {
            companyDataService.getCurrentUserGM().then(function (currentUserGM) {
                if (currentUserGM !== null) {
                    $scope.Substitute = currentUserGM.Substitute;
                    if ($scope.Substitute != null) {
                        var subDate = null;
                        if ($scope.Substitute.To) {
                            subDate = new Date($scope.Substitute.To);
                            subDate.setHours(23, 59, 59);
                        }

                        if (subDate != null && subDate > Date.now()) {
                            $scope.setSubstitutes = $scope.Substitute.ToSubstituteName;
                        } else {
                            $scope.Substitute = {};
                        }
                    }
                }
            }, function (data) {
                console.log(data);
            });
        }
    }

    this.$onDestroy = function () {
        authorizationDataLoadedEvent();
    };

    if ($rootScope.userData) {
        getCurrentSubstitute();
    }
}